module.exports = __webpack_public_path__ + "static/media/img_overpaper4.2e8de791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_overpaper4.png
// module id = 967
// module chunks = 0